export const PRODUCT_AVAILABILITY = 'Product Availability';

export const ACCOUNT_BUILDER_SERVICE = 'Account Builder Service';

export const USER_NOTIFICATION = 'User Notification';

export const ORDER_HISTORY = 'Order History';

export const ORDER_NOTIFICATION_PREFERENCES = 'Order Notification Preferences';

export const REPAIR_WARRANTY_PREFERENCES = 'Repair Warranty Preferences';

export const SHIPPING_PREFERENCES = 'Shipping Preferences';

export const INVOICE_DELIVERY_PREFERENCES = 'Invoice Delivery Preferences';

export const PRODUCT_DETAIL = 'New PDP';

export const CX_2019 = 'CX 2019';

export const PRICING = 'Pricing';

export const CHANGE_SHIPPING_METHOD = 'Change Shipping Method';
export const CHANGE_SHIPPING_METHOD_ID = 'Change_Shipping_Method';
export const CHANGE_SHIPPING_ADDRESS = 'Change Shipping Address';
export const CHANGE_SHIPPING_ADDRESS_ID = 'Change_Shipping_Address';
export const ORDER_MANAGEMENT = 'Order Management';
export const EXPECTED_SHIP_DATE_ID = 'Expected_Ship_Date';
export const EXPECTED_SHIP_DATE = 'Expected Ship Date';

export const CANCEL_ORDER = 'Cancel Order';
export const CANCEL_ORDER_ID = 'Cancel_Order';
export const ADD_ITEMS_TO_ORDER = 'Add Item(s)';
export const ADD_ITEMS_TO_ORDER_ID = 'Add_Item(s)';
export const DELETE_ITEMS_FROM_ORDER = 'Delete Item(s)';
export const DELETE_ITEMS_FROM_ORDER_ID = 'Delete_Item(s)';
export const BUY_ITEMS_AGAIN = 'Buy these items again';
export const BUY_ITEMS_AGAIN_ID = 'Buy_these_items_again';
export const ORDER_TRACKER = 'Order Tracker';
